// extracted by mini-css-extract-plugin
module.exports = {"p":"TypographyPage_p__WShFA","pBold":"TypographyPage_pBold__218Cl","pLight":"TypographyPage_pLight__239Ou"};